import React, { useEffect, useState } from 'react';
import BaseNav from 'react-bootstrap/Nav';
import { AccountButton } from './AccountButton';
import { getLoginUrl } from '../../utils/navigation';
export const BasicNavItem = ({ name, link: linkOrFunction, openInNewTab = false, onNavigate = () => { }, }) => {
    const isFunction = typeof linkOrFunction === 'function';
    const target = openInNewTab ? '_blank' : undefined;
    const [link, setLink] = useState(isFunction ? undefined : linkOrFunction);
    useEffect(() => {
        if (!isFunction) {
            setLink(linkOrFunction);
        }
        else {
            setLink(undefined);
        }
    }, [linkOrFunction, isFunction]);
    if (link === '/account') {
        return (React.createElement(AccountButton, { onPress: () => onNavigate(link) }));
    }
    else if (link === '/login') {
        return (React.createElement(BaseNav.Item, null,
            React.createElement(BaseNav.Link, { onClick: () => onNavigate(getLoginUrl()) }, name)));
    }
    else if (link?.startsWith('/')) {
        return (React.createElement(BaseNav.Item, null,
            React.createElement(BaseNav.Link, { onClick: () => onNavigate(link) }, name)));
    }
    else {
        return (React.createElement(BaseNav.Item, null,
            React.createElement(BaseNav.Link, { target: target, href: !isFunction ? linkOrFunction : '', onClick: isFunction ? () => onNavigate(linkOrFunction()) : undefined }, name)));
    }
};
//# sourceMappingURL=BasicNavItem.js.map